import { createContext } from "react";
import { User } from "@domain/user";
//set initial value of user to null (pre-login)
export const UserContext = createContext<User | undefined>(undefined);
